export var lexieBaseUrl = process.env.REACT_APP_LEXIE_BASE_URL || '';
